import { React } from 'react'
import Foto1 from '../images/foto1.jpg';

const About = () => {
  return (
    <>
      <div className='about-me row' id='about'>
        <div className='col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 my-picture'>
          <img src={Foto1} alt='error' />
        </div>
        <div className='col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 my-about-me'>
          <h2>About me</h2>
          <p>&emsp; My name is Shahzodbek. I work as a Front End Middle Developer. I have studied most of my experiences independently. I am a middle level programmer on the Front End Section of Web Programming. <br />
            &emsp; My experiences: <br />
            HTML, CSS, SASS, BOOTSTRAP, JAVASCRIPT, JQUERY, REACT, REDUX, TYPESCRIPT. <br />
            &emsp; I have a strong knowledge of established technologies and their internal libraries. I focus on making Web Sites Perfect. That is, I pay attention to the fact that the old version will open on browsers as well as on any mobile device. You can see most of my projects in the Portfolio Department.</p>
        </div>
      </div>
    </>
  )
}

export default About